import md5 from 'blueimp-md5';

///////////////////////////////////////////////////
/**
 * Google analytics Ecommerce
 *
 * Helpers: BookingList and ProductList
 * Events tracked: 'add to cart', 'checkout', 'payment', 'impression', 'product click', 'details'
 */
///////////////////////////////////////////////////

 //Helper - List of booked items
export function BookingList(item, ISOCurrencyCode) {
  let products = [];
  for (let i = 0; i < item.length; i++) {
    products.push({
      name: item[i].tour_name,
      id: item[i].tour_id,
      price: item[i].client_bookings[0].price,
      brand: "",
      category: "",
      variant: "",
      list: "",
      position: "",
      quantity: item[i].client_bookings.length,
      country: ISOCurrencyCode
    });
  }
  return products;
}

//Helper - List of products in basket
export function ProductList(item) {
  let products = [];
  for (let i = 0; i < item.length; i++) {
    products.push({
      name: item[i].fields.name,
      id: item[i].fields.tourId,
      price: "",
      brand: "",
      category: "",
      variant: "",
      list: "",
      position: ""
    });
  }
  return products;
}


//Helper - total revenue
export function PurchaseTotalRevenue(arr){
  let _price = 0;
  let _discount = 0;
  for(let i=0; i < arr.length; i++){
    _price += arr[i].price;
    _discount += arr[i].discount;
  }
  let _result = _price - _discount;
  return _result.toFixed(2);
}

//Helper - all totals
export function AllBookTotal(arr, arrValue){
  let _total = 0;
  for(let i=0; i < arr.length; i++){
    _total += arr[i][arrValue];
  }
  return _total.toFixed(2);
}

//Event - add to basket
export function AddToBasket(arr) {
  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {

    let basketObj = {
      name: arr.bookings[0].tour_name,
      id: arr.bookings[0].tour_id,
      price: arr.bookings[0].client_bookings[0].price,
      brand: "",
      category: "",
      variant: "",
      list: "",
      position: "",
      quantity: arr.bookings[0].client_bookings.length,
      country: arr.bookings[0].iso_currency_code
    }


    window.dataLayer.push({
      event: "addToCart",
      category: 'Ecommerce',
      action: 'addToCart',
      label:'addToCart',
      ecommerce: {
        currencyCode: arr.bookings[0].iso_currency_code,
        add: {
          products: basketObj
        }
      }
    });

    //Criteo tracking
    CriteoBasketpage(arr.bookings, arr.clients[0].email);

 }
}


//Event - checkout
export function CheckOut(products) {
  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      event: "checkout",
      category: 'Ecommerce',
      action: 'checkout',
      label:'checkout',
      ecommerce: {
        currencyCode: products.bookings[0].iso_currency_code,
        checkout: {
          products: BookingList(products.bookings, products.bookings[0].iso_currency_code)
        }
      }
    });
  }
}


//Event - purchase
export function Purchase(products) {

  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      category: 'Ecommerce',
      action: 'payment',
      label:'payment',
      ecommerce: {
        currencyCode: products.bookings[0].iso_currency_code,
        purchase: {
          actionField: {
            id: products.group_booking_id,
            affiliation: "Online Store",
            revenue: PurchaseTotalRevenue(products.bookings[0].client_bookings),
            tax: 0,
            shipping: 0,
            coupon: ""
          },
          products: BookingList(products.bookings, products.bookings[0].iso_currency_code)
        }
      },
      totals:{
        totalDiscount:AllBookTotal(products.bookings[0].client_bookings, "discount"),
        totalPaid:AllBookTotal(products.bookings[0].client_bookings, "paid"),
        totalPrice:AllBookTotal(products.bookings[0].client_bookings, "price"),
        totalDeposit:AllBookTotal(products.bookings[0].client_bookings, "deposit"),
        totalOutstanding:AllBookTotal(products.bookings[0].client_bookings,"outstanding")
      }
    });

    // Criteo confirmation tracker
    CriteoConfirmationpage(products.bookings, products.group_booking_id, products.clients[0].email)

    //Doubleclick RaQ tracking counter
    doubleClickRaQ(products.bookings[0].iso_currency_code);
  }
}


//Measures products impressions
//Product impression by pushing impression object
export function ProductImpressions(productsObj, ISOCurrencyCode) {
  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      ecommerce: {
        currencyCode: ISOCurrencyCode,
        impressions: ProductList(productsObj)
      }
    });
  }
}


//Measure product clicks
export function ProductClick(products){

  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      event: "productClick",
      category: 'Ecommerce',
      action: 'productClick',
      label: products.name,
      ecommerce: {
        click: {
          products: [
            {
              name: products.name,
              id: products.tourId,
              price: "",
              brand: "",
              category: products.categoryWhere.fields.name,
              variant: products.category.fields.name,
              position: ""
            }
          ]
        }
      }
    });

    //ReactGA.event({category: 'Ecommerce', action: 'productClick', label:'productClick'});
  }

}

//Measure view of product detail (basket stage)
export function ProductDetailsView(products) {
  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      ecommerce: {
        detail: {
          products: [
            {
              name: products.name,
              id: products.tour_id,
              price: "",
              brand: "",
              category: "",
              variant: "",
              position: ""
            }
          ]
        }
      }
    });
  }
}
///////////////////////////////////////////////////



///////////////////////////////////////////////////
/**
 * Criteo tracking
 *
 * Helpers: criteoProductsUtil
 * Events tracked: 'homepage', 'listingpage', 'productpage', 'basketpage', 'confirmation'
 */
///////////////////////////////////////////////////
export function criteoProductsUtil(item){
     var criteoBasket = [];
     for(var i = 0; i < item.length; i++){
         criteoBasket.push({
             id:item[i].tour_id,
             name:item[i].tour_name,
             price:item[i].client_bookings[0].price,
             quantity:item[i].client_bookings.length
         })
     }
     return criteoBasket;
 }

export function CriteoHomepage() {
  if (process.env.REACT_APP_ENV === "production"  || process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      event: "HomePageView",
      PageType: "Homepage",
      HashedEmail: ""
    });
  }
}

export function CriteoListingpage(productArray) {
  if (process.env.REACT_APP_ENV === "production"  || process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      event: "ListingPageView",
      PageType: "Listingpage",
      HashedEmail: "",
      ProductIDList: ProductList(productArray)
    });
  }
}

export function CriteoProductpage(productID) {
  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      event: "ProductPageView",
      PageType: "Productpage",
      HashedEmail: "",
      ProductID: productID
    });
  }
}

export function CriteoBasketpage(productsList, hashedEmail) {
  if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      event: "BasketPageView",
      PageType: "Basketpage",
      HashedEmail: md5(hashedEmail),
      ProductBasketProducts: criteoProductsUtil(productsList)
    });
  }
}

export function CriteoConfirmationpage(productsList, transactionID, hashedEmail) {
  if (process.env.REACT_APP_ENV === "production"  ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    window.dataLayer.push({
      event: "TransactionPageView",
      PageType: "Transactionpage",
      HashedEmail: md5(hashedEmail),
      ProductTransactionProducts: criteoProductsUtil(productsList),
      TransactionID: transactionID
    });
  }
}

///////////////////////////////////////////////////


///////////////////////////////////////////////////
/**
 * Doubleclick RaQ Tracking
 */
///////////////////////////////////////////////////
export function doubleClickRaQ(currency){
if (process.env.REACT_APP_ENV === "production" ||  process.env.REACT_APP_TRACKING_DEBUG === "true") {
    if(currency === "USD"){
        window.dataLayer.push({ event:"USA_DoubleClick_RaQ" });
    }
    if(currency === "CAD"){
        window.dataLayer.push({ event:"CA_DoubleClick_RaQ" });
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/analytics.js